<template>
  <div>
 
 


 


 

  <div  >





 
 





<div style="z-index: 10000;position: fixed;bottom: 0;left: 0;right: 0;padding:10px 27px;background: #fff;" class="d-md-none d-flex align-items-center justify-content-between">


  






  <div
 
v-bind:class="[{ botactive: $route.path.toLowerCase()=='/'+info.name.toLowerCase()},{ botnotactive: $route.path.toLowerCase()!='/'+info.name.toLowerCase() },{navclass:true}]"  >


    <router-link to='/' style='text-decoration:none'>

 <img src="./images/files/homeblack.svg" style="transform:translateY(-1px)" >



</router-link>
</div>


 
 





   <div  class="botactive navclass"   style="position:relative">
    <router-link to='/bag' style='text-decoration:none'>

<div style="width:16px;height:16px;background:#fff;border-radius:50%; z-index:10000;   position: absolute;
    top: 3px;
    right: 4px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#EB3838;font-size:10px;font-weight:700">{{rendercartlength}}</span>
</div>
 <img src="./images/files/bagwhite.svg"  style="width:20px;transform:translateY(-1px)" >

  </router-link>
  </div>




   <div v-bind:class="[{ botactive:$route.path=='/'+$route.path.split('/')[1]+'/account'  },{ botnotactive: !($route.path=='/account') },{navclass:true}]" v-on:click='account'>
        

 <img src="./images/files/user.svg" style="width:20px;transform:translateY(-1px)"   >
 
  </div>
   
</div>








<!--headerr--> 

 

   

<div  class="  pt-md-4 pb-md-4 pt-3 pb-3  headerwrapper" style="position:sticky;top:0px;background:#fff;z-index:10000000">
  <div class="container  ">

  <div class="headerui     ">
    <router-link  to="/" style='text-decoration:none'>
<div class="d-flex align-items-center mr-4  logowrapper">
  
  <img src="./images/finallogo.png" style="" class="logohigh">
</div>
</router-link>
 






<div class="d-flex align-items-center  navwrapper  ml-3   ">
  

  <div class="d-none align-items-center contactwhatsapp" style="">
    
    <img src="https://cdn.usbrandcolors.com/images/logos/whatsapp-logo.svg" style="width:20px;margin-right:6px;min-width:20px;">

 <p style="font-weight:600;color:#fff;font-size:13px">WhatsApp</p>

  </div>


 
  <router-link    to="/bag"  style='text-decoration:none'>
  <div class="d-flex align-items-center navitem pl-4 ml-4" style="position:relative;margin-left:30px">
    
          <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>


    <div style="width:16px;height:16px;background:#EB3838;border-radius:50%;    position: absolute;
    top: 2px;
    right: 10px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:11px;font-weight:600">{{rendercartlength}}</span>
</div>



 <svg width="17" height="20" viewBox="0 0 17 20" fill="#0B0A23" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.7" d="M15 5.83333H11.6667V3.33333C11.6667 1.4925 10.1742 0 8.33333 0C6.4925 0 5 1.4925 5 3.33333V5.83333H1.66667L0 20H16.6667L15 5.83333ZM5.83333 3.33333C5.83333 1.955 6.955 0.833333 8.33333 0.833333C9.71167 0.833333 10.8333 1.955 10.8333 3.33333V5.83333H5.83333V3.33333ZM5 7.5V8.75C5 8.98 5.18667 9.16667 5.41667 9.16667C5.64667 9.16667 5.83333 8.98 5.83333 8.75V7.5H10.8333V8.75C10.8333 8.98 11.02 9.16667 11.25 9.16667C11.48 9.16667 11.6667 8.98 11.6667 8.75V7.5H13.5183L13.9108 10.8333H2.75667L3.14917 7.5H5Z" fill="#0B0A23"/>
</svg>

 


  </div>
</router-link>


   <div class="d-flex align-items-center    " style="position:relative;padding-left:50px"  >
      
      <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>

      <p class="mya" style="color: #0B0A23;

opacity: 0.8;font-weight: 500;
font-size: 14px;" v-on:click='account'>My Account</p>

<div v-if='user' style="position:absolute;top:0px;left:50%;transform:translateX(-50%);padding-top:40px;cursor:pointer" class="opanav">


  <div style="width:170px;background:#fff;border-radius:4px;box-shadow:0 0 10px rgba(0,0,0,0.1)">

    <router-link to='/whishlist' style='text-decoration:none'>
    <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Wishlist</p>
  </router-link>
   <router-link to='/account' style='text-decoration:none'>
       <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Account</p>
     </router-link>
          <p class="navhover"   v-on:click='logout' style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Logout</p>
  </div>
</div>


  </div>






</div>

</div>

  </div>
  
</div>






<div class="pt-md-4 pb-md-5 pt-0 pb-3  headerwrapper2  fixheight" style="">
  <div class="container pads ">
  <div class="   ">





<div class="row justify-content-center" style="margin:0px">

  <div class="col-md-8 mobcol" >
    <div style="border:none!important" class="orderwrapper ordersuc">


<div  class="px-md-5 pt-md-4 p-0" >
 
 <div class= "p-0 p-0 "  style="text-align: center;">
                   



                 <div  style="" >

<div class="d-md-flex d-none align-items-center justify-content-center    "  >
   



</div>

<div class="d-md-none d-flex align-items-center justify-content-start    "  >
  
     <router-link    to='/' style='text-decoration:none'>
   <svg width="21"  v-on:click="tab='address'" height="14" viewBox="0 0 21 14" style='cursor:pointer' fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.363604 6.3636C0.012132 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987511 7.36396 0.636039C7.01249 0.284567 6.44264 0.284567 6.09117 0.636039L0.363604 6.3636ZM1 7.9H21V6.1H1V7.9Z" fill="#0B0A23"/>
</svg>

</router-link>


<p  class="shopbag" style="margin-left:20px;margin-top:0px!important" >Payment
</p>


</div>


<div class="d-flex align-items-center justify-content-center">
  

    <div style="width:300px;max-width:90%;margin:0px auto" class="    ">
      <img src="https://firebasestorage.googleapis.com/v0/b/sayra-a4201.appspot.com/o/Pyment%20decline11.png?alt=media&token=2068bfaa-c505-4cac-bb6a-88311fded323" style="width:100%">
    </div>
    </div>
  
                           
<p  class="shopbag" style="margin-left:20px;margin-top:0px!important;color:#E33530" >Payment Failed
</p>
                        </div>
                   
                           <p   style="font-size:20px" class="subtxt">Unfortunately , the payment was declined</p>  
                          <div class="d-flex flex-wrap   justify-content-center " style=" margin-top:26px" >
                            

                            <div style="   " class="statusbtn" >
                              <div style="" class="rightshop"  v-on:click='gohome' >
                                Back to home
                              </div>
                                
                            </div>
                      
                           </div>   



             </div>

</div>




 
 

 
</div>

  </div>
</div>





 



 
 </div>

  </div>
  
</div>
 

 
 


 






 
 </div>

  
  </div>
</template>

<script>
 import firebase from 'firebase'

 
const fb = require('./firebaseconfig.js')
 
export default {
        props: ['loadstatus','info','products','category','deals','addcart','test','carts','orders','uids'],

  
  data () {

        return{
  sendotpclicked:false,
       otpenterd:true,
       otpvalue:'',

        }
     
    
  },
  created(){
  var vm=this;
 
 if(firebase.auth().currentUser){



     this.user=true
 }else{
       this.user=false
 }


 
 



 

   },
   methods:{ 

 
 


      logout(){
        var vm=this

        fb.auth.signOut().then(function() {
 
vm.user=false
vm.$router.push({ path: '/'  })

}).catch(function(error) {
 
});
      },

gohome(){
       this.$router.replace({ path: '/'})

},
 

    trackorder(){
 
      this.$router.replace({ path: `/orderdetails/${this.$route.query.orderid}`
 })

    },

     account(){


     if(firebase.auth().currentUser){

//alert('yes')


this.$router.push({ path: '/account' })

 }else{
this.loginbox=true
 }
    },
    
 

   },
   computed:{

    rendercartlength(){

var cartlength=0
        var x=this.carts.forEach((itm)=>{

           cartlength=Number(itm.quantity)+cartlength
        })
        return cartlength

    },
   }

    
 
  
}
</script>
<style scoped >
  

</style>
 



// WEBPACK FOOTER //
// src/paymentfailure.vue